import { Icon } from '../icon/Icon';
import { DateDisplayProps, useDateDisplay } from './use-date-display.hook';

export const DateDisplay = (props: DateDisplayProps): React.ReactElement => {
    const { formattedStartDate, formattedEndDate } = useDateDisplay(props);

    return (
        <>
            {formattedStartDate}
            {formattedEndDate && (
                <>
                    <Icon iconClassName="mx-2 small" icon="arrow-right" />
                    {formattedEndDate}
                </>
            )}
        </>
    );
};
